module.exports = __webpack_public_path__ + "img/dj.b08163df.svg";